import { useEffect, useState } from "react";
import * as invoicesActionCreators from "../actions/invoices";
import * as invoicesActionCreatorsGas from '../actions/invoicesGas';
import { useSearchParams } from "react-router-dom";
import { IFilter } from "../types/filter";
import { useSettingsContext } from "@/components/Settings/hooks/useSettingsContext";
import { useAppDispatch, useAppSelector } from "@/hooks";

const actions = {
  electricity: invoicesActionCreators,
  gas: invoicesActionCreatorsGas
}

export interface IUseInvoicesProps {
  type: 'electricity' | 'gas';
}

export const useInvoices = ({ 
  type
}: IUseInvoicesProps) => {
  const Settings = useSettingsContext();
  const dispatch = useAppDispatch();
  const [searchParams, setSearchParams] = useSearchParams();

  const invoices = useAppSelector(state => state.invoices[type].items ?? []);
  const itemsOffset = useAppSelector(state => state.invoices[type].itemsOffset);
  const itemsPage = useAppSelector(state => state.invoices[type].itemsPage);
  const loaded = useAppSelector(state => state.invoices[type].loaded);
  const errors = useAppSelector(state => state.invoices[type].errors);
  const currentFilter = useAppSelector(state => state.invoices[type].filters.currentFilter);
  const token = useAppSelector(state => state.auth.token);


  const [initialFilter, setInitialFilter] = useState<IFilter[]>([]);
  const [initialItemsPage, setInitialItemsPage] = useState<number>(Settings?.invoices?.itemsPerPage ?? 100);

  useEffect(() => { //Runs when component is mounted/unmounted
    dispatch(actions[type].fetchFilters(token, type));
  }, []);

  useEffect(() => {  //Runs when the url parameter 'contractName' changes
    const contractName = searchParams.get("contractName");
    if (contractName) {
      setInitialFilter([
        {
          category: { type: "autocomplete", renderText: "Contracte", searchField: "polissa_id.name" },
          value: [contractName], 
          type: 'contains'
        }
      ]);
      dispatch(actions[type].fetchInvoices({token, filters: `('polissa_id.name', 'in', ['${contractName}'])`, limit: initialItemsPage}));
    } else {
      setInitialFilter([]);
      dispatch(actions[type].fetchInvoices({token, limit: initialItemsPage}));
    }
    setInitialItemsPage(Settings?.invoices?.itemsPerPage ?? 100);
  }, [searchParams.get("contractName")]);

  const fetchData = () => {
    dispatch(actions[type].fetchInvoices({token, filters: currentFilter, offset: itemsOffset, limit: itemsPage}));
  };

  const applySearchFilter = (newFilters: string, newItemsPage: number) => {
    const newItemsOffset = newItemsPage !== itemsPage ? 0 : itemsOffset;
    setInitialItemsPage(newItemsPage);

    dispatch(actions[type].fetchInvoices({token, filters: newFilters, offset: newItemsOffset, limit: newItemsPage}));
  };

  const handleItemsOffset = (newOffset: number) => {
    dispatch(actions[type].fetchInvoices({token, filters: currentFilter, offset: newOffset, limit: itemsPage}));
  }; 

  return { 
    invoices,
    loaded,
    errors,
    initialFilter,
    initialItemsPage,
    fetchData,
    applySearchFilter,
    handleItemsOffset
  }
}

